import _ from 'lodash';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBaseCodes } from '../modules/auth';

// ----------------------------------------------------------------------

export default function useComCodes() {
  const dispatch = useDispatch();
  const { codes } = useSelector(({ auth }) => ({
    codes: auth.baseCodes,
  }));

  useEffect(() => {
    if (!codes || codes.length === 0) {
      dispatch(getBaseCodes());
    }
  }, [codes]);

  // revVal1를 가져오는 함수
  const getRevVal1 = (filters) => {
    const revVal1 = _.get(_.find(codes, filters), 'revVal1');

    return revVal1;
  };

  const getCode = (filter) => {
    const code = _.find(codes, filter);
    return code;
  };

  const getFilteredList = (filters) => {
    const filteredList = _.filter(codes, filters).map((item) => ({
      ...item,
      step: item.step !== '' && item.step !== null ? Number(item?.step) : 0,
    }));
    const orderedList = _.orderBy(filteredList, 'step');
    return orderedList;
  };

  return {
    getRevVal1,
    getCode,
    getFilteredList,
  };
}
